import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    if (user?.role === "admin") nav("/admin", { replace: true });
    else if (user?.role === "distributor") nav("/distributors/portal", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("This login is for administrators only.");
        return;
      }
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err.message || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F1A12] text-white flex items-center justify-center p-6" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <p className="text-[0.7rem] font-bold uppercase tracking-[0.36em] text-[#E8B14B] mb-3">Hupla · Admin</p>
        <h1 className="font-editorial italic text-4xl mb-8">Sign in.</h1>
        <form onSubmit={submit} className="space-y-3">
          <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2.5 text-sm" data-testid="admin-login-email" />
          <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-lg border border-white/15 bg-white/5 px-3 py-2.5 text-sm" data-testid="admin-login-password" />
          <button type="submit" disabled={busy} className="w-full rounded-full bg-[#E8B14B] text-[#0F1A12] py-2.5 text-sm font-semibold disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-8 text-xs text-white/50">
          Distributor? <Link to="/distributors/login" className="underline hover:text-white">Distributor sign in →</Link>
        </p>
      </div>
    </div>
  );
}
